import React from "react";
import competences_categories from "../data/competences";

const SkillItem = ({ skill }) => (
  <div className="bg-gray-50 rounded p-4 transition-colors">
    <div className="flex items-start">
      <div className="flex-shrink-0 w-2 h-2 bg-primary rounded-full mt-2 mr-3"></div>
      <div className="flex-1">
        <h4 className="font-semibold text-gray-900 mb-1">{skill.name}</h4>
        <p className="text-sm text-gray-600">{skill.description}</p>
      </div>
    </div>
  </div>
);

const CategorySection = ({ category, data }) => (
  <div className="bg-white rounded p-6 shadow-sm border border-gray-100">
    <div className="flex items-start mb-4">
      <span className="text-3xl mr-4 mt-1">{data.icon}</span>
      <div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">{data.title}</h3>
        <p className="text-gray-600 text-sm">{data.description}</p>
      </div>
    </div>
    <div className="grid gap-3">
      {data.skills.map((skill, index) => (
        <SkillItem key={index} skill={skill} />
      ))}
    </div>
  </div>
);

const Competences = () => {
  return (
    <div className="pt-24 lg:pt-32 relative overflow-hidden">
      {/* Arrière-plan animé avec bulles décoratives */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50"></div>
      {/* Décorations allégées ou supprimées pour un style plus sobre */}

      <div className="relative lg:mx-auto lg:max-w-7xl lg:w-full lg:pb-20">
        <div className="lg:px-8 px-4">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="lg:tracking-tight font-extrabold text-gray-900 lg:text-6xl text-4xl mb-6">
              Mes Compétences
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Technologies et compétences développées à travers mes expériences
              professionnelles et projets
            </p>
          </div>

          {/* Skills Categories */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Domaines d'Expertise
            </h2>
            <div className="grid lg:grid-cols-2 gap-6">
              {Object.entries(competences_categories).map(([key, category]) => (
                <CategorySection key={key} category={key} data={category} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Competences;
